import { inject, Injectable, signal, WritableSignal } from '@angular/core';
import { SessionStorageService } from 'src/app/services/session-storage.service';

@Injectable({
  providedIn: 'root'
})
export class PlannerDayStateService {
  public dayToShowIndex: WritableSignal<number> = signal(0);
  
  public _sessionStorageService = inject(SessionStorageService);
  
  setDayToShowIndex(index: number): void {
    this.dayToShowIndex.set(index);
    this._sessionStorageService.setItem('dayToShowIndex', index);
  }
  
  resetDayToShowIndex(): void {
    this.dayToShowIndex.set(0);
    this._sessionStorageService.removeItem('dayToShowIndex');
  }
}
 